import { m } from "../../lib/paraglide/messages.js";

export const defaultExample = m.defaultExample();
export const rulesReminder = m.rulesReminder();
